/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { getState, Status, isEmpty, arrayFrom } from '../twd/twd'

const Last = getState('order-ticket-order-info.last', {
    ts: 0,
    orderInfo: {},
    hasOrderInfo: false,
    orderInfoStatus: Status.NULL,
})

export const resetLastOrderInfo = ({ts=0} = {}) => {
    Last.reset()
    Last.set({
        ts,
        orderInfo: {},
        hasOrderInfo: false,
        orderInfoStatus: Status.NULL,
    })
}

const TransactionType = {
    'W': 'Sell Quote (Bid Wanted)',
    'F': 'Buy Quote (Offer Wanted)',
    'B': 'Buy',
    'S': 'Sell',
}

export default ({setModals, from, } = {}) => {

    const [orderInfo, setOrderInfo_] = React.useState(Last.value.orderInfo || {})
    const setOrderInfo = React.useCallback((orderInfo_) => {
        orderInfo_ = orderInfo_ || {}
        const { statusMsg, offerings, action } = orderInfo_

        orderInfo_.max_qty_avail = orderInfo_.qty_max
        orderInfo_.sugg_comm_in_dlrs_per_tckt = orderInfo_.sugg_comm_in_dlrs_per_tckt || 0
        orderInfo_.netMoney = orderInfo_.netMoney || 0
        orderInfo_.transactionType = TransactionType[action]

        if (!isEmpty(offerings)) {
            const o = arrayFrom(offerings)
                .sort(({availQty:a}, {availQty:b}) => b-a)[0] || {}

            const availQty = parseFloat(o.availQty)
            orderInfo_.max_qty_avail = Math.max(orderInfo_.max_qty_avail, !isNaN(availQty) ? availQty : 0)
        }

        if (statusMsg) {

            // remove max qty error
            if (statusMsg.indexOf('12105')>=0) {
                orderInfo_.statusMsg = ''
            }

            // check if duplicate order
            if (orderInfo_.statusMsg.indexOf('12891')>=0) {
                orderInfo_.statusMsg = orderInfo_.statusMsg.replaceAll('(12891)','')
                setModals({
                    view:'order-ticket-duplicate-order-modal',
                    from,
                })
            }

            if (orderInfo_.statusMsg.startsWith("ERROR:")) {
                orderInfo_.statusMsg = orderInfo_.statusMsg.replace("ERROR:", "ERROR: ")
            }

            orderInfo_.statusMsg = orderInfo_.statusMsg.replace(
                'Click Save & Preview or Save & Enter Another Account',
                'Click Preview')
        }

        Last.set({orderInfo:orderInfo_})
        setOrderInfo_(orderInfo_)

        setHasOrderInfo(
            Object.keys(orderInfo_).length>0)

        const s = orderInfo_.statusMsg || ''
        const f = s.indexOf('NO OFFERINGS FOR TICKET') > 0
            || s.indexOf('NO ORDER CONFIGURED FOR TICKET') > 0
        orderInfo_.hasMarket = !f
        setHasMarket(!f)

        // remove any additions added to the issuer name
        if (orderInfo_.issue) {
            orderInfo_.issue = orderInfo_.issue.replaceAll(/<span.*/g, '')
        }

        return orderInfo_
    }, [])

    const [hasMarket, setHasMarket_] = React.useState(Last.value.hasMarket || false)
    const setHasMarket = React.useCallback((hasMarket) => {
        Last.set({hasMarket})
        setHasMarket_(hasMarket)
    }, [])


    const [hasOrderInfo, setHasOrderInfo_] = React.useState(Last.value.hasOrderInfo || false)
    const setHasOrderInfo = React.useCallback((hasOrderInfo) => {
        Last.set({hasOrderInfo})
        setHasOrderInfo_(hasOrderInfo)
    }, [])

    const [orderInfoStatus, setOrderInfoStatus_] = React.useState(Last.value.orderInfoStatus || Status.NULL)
    const setOrderInfoStatus = React.useCallback((orderInfoStatus) => {
        Last.set({orderInfoStatus})
        setOrderInfoStatus_(orderInfoStatus)
    }, [])

    const [hiddenState, setHiddenState_] = React.useState(Last.value.hiddenStates || {})
    const setHiddenState = React.useCallback((hiddenState) => {
        Last.set({hiddenState})
        setHiddenState_(hiddenState)
    }, [])

    const reset = () => {
        Last.reset()
        setHasOrderInfo(false)
        setOrderInfo({})
        setOrderInfoStatus(Status.NULL)
        setHiddenState({})
    }

    return {
        orderInfo, setOrderInfo,
        hasOrderInfo, setHasOrderInfo,
        orderInfoStatus, setOrderInfoStatus,
        hiddenState, setHiddenState,
        hasMarket, setHasMarket,
        reset,
    }

}
